// extracted by mini-css-extract-plugin
module.exports = {"menu":"MainMenu_menu__1vYtT"};